enum STORES {
  UI = 'af-stores_ui'
}

enum STORAGE {
  FILTER = 'af-storage_filters'
}

export { STORES, STORAGE };